import mapValues from 'lodash/mapValues'
import { groupByHealthProcedureType } from './groupBy'
import { sanitizeHealthProceduresType } from './helpers'
import { IHealthProcedures } from '~/interfaces'

interface GroupByTypeReturn {
  [x: string]: {
    type: string
    healthProcedures: IHealthProcedures[]
  }
}

export const createRowSlotsByHealthProcedureType = (healthProcedures: IHealthProcedures[]): GroupByTypeReturn => {
  const groupedByType = groupByHealthProcedureType(healthProcedures)

  const rowSlotsContent = mapValues(groupedByType, (groupedPerTypeHealthProcedures: IHealthProcedures[]) => {
    return {
      type: sanitizeHealthProceduresType(groupedPerTypeHealthProcedures[0]),
      healthProcedures: groupedPerTypeHealthProcedures
    }
  })

  return rowSlotsContent
}
